const heroLayoutClassNames = (layout) => {
    switch (layout) {
        case 'banner':
            return 'hero-widget--banner';
        case 'hero':
            return 'hero-widget--hero';
        default:
            return '';
    }
};
export { heroLayoutClassNames };
